import { render, staticRenderFns } from "./ChatQuoteMessage.vue?vue&type=template&id=1d2dc36b&scoped=true"
import script from "./ChatQuoteMessage.vue?vue&type=script&lang=js"
export * from "./ChatQuoteMessage.vue?vue&type=script&lang=js"
import style0 from "./ChatQuoteMessage.vue?vue&type=style&index=0&id=1d2dc36b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2dc36b",
  null
  
)

export default component.exports